import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import InitiativeValidations from 'scaleflow/validators/initiative';
import { task } from 'ember-concurrency';

export default class RoadmapTableInitiativeSettingsGeneralDetailsController extends Controller {
  @service('beta-toggle') betaService;
  initiativeValidations = InitiativeValidations;
  @service router;

  @action
  resetForm(changeset, e) {
    e.preventDefault();
    changeset.rollback();
  }

  saveSettings = task({}, async (changeset, e) => {
    e.preventDefault();
    if (changeset.get('isDirty')) {
      this.nothingChanged = false;
      changeset.validate().then(() => {
        if (changeset.get('isValid')) {
          changeset
            .save()
            .then(() => {
              this.submittedOnce = true;
            })
            .catch((err) => {
              console.log(err, 'err');
              changeset
                .get(this, 'model.errors')
                .forEach(({ attribute, message }) => {
                  changeset.addError(attribute, message);
                });
            });
        }
      });
      // if there is an extra action that needs to be done after the form is submitted
    } else {
      this.saveSettings.cancelAll();
    }
  });

  @action
  deleteInitiative() {
    this.model
      .destroyRecord()
      .then(() => this.router.transitionTo('backlog.initiatives'));
  }
}
